import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../shared/services/admServices/dashboard.service';
import { browserRefresh } from '../../../app.component';
import { SignalrService } from 'src/app/shared/services/websecket/signalr.service';

@Component({
  selector: 'adm-dash-component',
  templateUrl: './dash-component.html',
  styleUrls: ['./dash-component.scss']
})

export class dashboardComponent implements OnInit {
  public browserRefresh: boolean;

  profToday: any;
  profYeste:any;
  profMonth: any;
  top4: any;

  chartData: any;
  chartOption: any;

  constructor(private dashboardService: DashboardService, private signalrService: SignalrService) {}

  ngOnInit() {
    // weryfikacja czy nastąpiło refreshe page (F5)
    this.browserRefresh = browserRefresh;
    if(this.browserRefresh)
    {
      this.signalrService.startConnection();
      this.signalrService.newConversionListener();
    }

    this.getDashboard();
   }

   getDashboard(){
    this.dashboardService.getDashboard()
    .subscribe(
     data => {
      this.profToday = data.data.todayStatistics;
      this.profYeste = data.data.yesterdayStatistics;
      this.profMonth = data.data.monthlyStatistics;
      this.top4 = data.data.topPublishers;
      this.chartData = data.data.profitsPerMonth;
      console.log("DATA: ", this.profToday);
      this.setChart();
     },
     error => {
       console.log(error);
     });
   }

  setChart(){
    this.chartOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          // Use axis to trigger tooltip
          type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
        }
      },
      legend: {},
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: this.chartData.months
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: 'Revenue $',
          type: 'bar',
          color: '#ff6018',
          stack: 'total',
          label: {
            show: true
          },
          emphasis: {
            focus: 'series'
          },
          markLine: {
            lineStyle: {
              width: 3,
              color: '#FE5103'
            },
            data: [{ type: 'average', name: 'Avg' }]
          },
          data: this.chartData.revenue
        },
        {
          name: 'Profit $',
          type: 'bar',
          color: '#5dab47',
          stack: 'total',
          label: {
            show: true
          },
          emphasis: {
            focus: 'series'
          },
          data: this.chartData.profit
        }
      ]
    };
  }

  ngOnDestroy(): void {}

}
